import { FormControl, InputLabel, MenuItem, Select, TextField, FormHelperText, Switch } from '@material-ui/core';
import React, { Component } from 'react';

/* Object Json */
import { safeDeepGet, safeDeepGetWithType, stringify, parse, deepClone, clean, isJsonEqual } from 'iotera-base/json';
import { isFunction, isEmpty } from 'iotera-base/object';
import { DUMMY_FILTER } from '../../../lib/components/dummy';
import { upperFirstLetter } from '../../../lib/components/formatter';

export class SelectionFilter extends Component {
  constructor(props) {
    super(props);
    let filters = [];
    filters.push({ 'value': 'LAST_MINUTE', 'param': 15, 'label': 'Last 15 minutes', 'type': 'minute', 'selector_name': 'Minute' });
    filters.push({ 'value': 'LAST_MINUTE', 'param': 30, 'label': 'Last 30 minutes', 'type': 'minute' });
    filters.push({ 'value': 'LAST_HOUR', 'label': 'Last 1 hour', 'param': 1, 'type': 'hour', 'selector_name': 'Hour' });
    filters.push({ 'value': 'LAST_HOUR', 'param': 3, 'label': 'Last 3 hours', 'type': 'hour' });
    filters.push({ 'value': 'LAST_HOUR', 'param': 6, 'label': 'Last 6 hours', 'type': 'hour' });
    filters.push({ 'value': 'LAST_HOUR', 'param': 12, 'label': 'Last 12 hours', 'type': 'hour' });
    filters.push({ 'value': 'LAST_DAY', 'label': 'Yesterday', 'type': 'day', 'selector_name': 'Day' });
    filters.push({ 'value': 'TODAY', 'label': 'Today', 'type': 'day' });
    filters.push({ 'value': 'LAST_WEEK', 'label': 'Previous week', 'type': 'week', 'selector_name': 'Week' });
    filters.push({ 'value': 'THIS_WEEK', 'label': 'This week', 'type': 'week' });
    filters.push({ 'value': 'LAST_MONTH', 'label': 'Previous month', 'type': 'month', 'selector_name': 'Month' });
    filters.push({ 'value': 'THIS_MONTH', 'label': 'This month', 'type': 'month' });
    filters.push({ 'value': 'LAST_YEAR', 'label': 'Previous year', 'type': 'year', 'selector_name': 'Year' });
    filters.push({ 'value': 'THIS_YEAR', 'label': 'This year', 'type': 'year' });
    this.state = {
      filters
    }
    this.handleChange = this.handleChange.bind(this);
  }
  handleChangeToggle = (name, value) => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let finalData = safeDeepGetWithType(_state, ['finalData'], {});
    if (!value) {
      finalData.is_default = true
    } else {
      delete finalData.is_default
    }
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    const isFunc = isFunction(checkSubmitable);
    _this.setState({ [name]: !value, finalData })
    const checkFinal = deepClone(finalData)
    delete checkFinal.name
    delete checkFinal.range
    delete checkFinal.range_param
    delete checkFinal.is_default
    if (checkFinal.period !== 'auto') {
      delete checkFinal.period
    }
    delete checkFinal.type;
    if (isFunc) {
      if (isEmpty(checkFinal)) {
        checkSubmitable('varValue', {});
      } else {
        checkSubmitable('varValue', finalData);
      }
    }
  }

  handleChange(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '');
    const value = safeDeepGet(event, ['target', 'value'], '');
    let finalData = safeDeepGetWithType(_state, ['finalData'], {});
    let checkSubmitable = safeDeepGet(_props, ['checkSubmitable'])
    const isFunc = isFunction(checkSubmitable);
    if (name === 'varFilter') {
      const valueObj = parse(value);
      const _value = safeDeepGetWithType(valueObj, ['value'], '')
      const filter_type = safeDeepGetWithType(valueObj, ['type'], '')
      const range_param = safeDeepGetWithType(valueObj, ['param'], 0)
      finalData.range = _value;
      finalData.range_param = range_param;
      _this.setState({
        [name]: value,
        filter_type,
        range_param,
        finalData,
        varPeriod: null,
        varInterval: null,
      })
      if (isFunc) {
        checkSubmitable('varValue', {});
      }
    } else if (name === 'varFLabel') {
      finalData.name = value;
      if (value === '') {
        delete finalData.name;
      }
      _this.setState({
        [name]: value,
        finalData
      })
      const checkFinal = deepClone(finalData)
      delete checkFinal.name
      delete checkFinal.range
      delete checkFinal.range_param
      delete checkFinal.is_default
      if (checkFinal.period !== 'auto') {
        delete checkFinal.period
      }
      delete checkFinal.type;
      if (isFunc) {
        if (isEmpty(checkFinal)) {
          checkSubmitable('varValue', {});
        } else {
          checkSubmitable('varValue', finalData);
        }
      }
    } else if (name === 'varPeriod') {
      finalData.period = value;
      _this.setState({
        [name]: value,
        varInterval: null,
        finalData
      })
      if (isFunc) {
        checkSubmitable('varValue', {});
      }
    } else if (name === 'varInterval') {
      finalData.interval = value;
      _this.setState({
        [name]: value,
        finalData
      })
      if (isFunc) {
        checkSubmitable('varValue', finalData);
      }
    } else if (name === 'varCustomPeriod') {
      let finalDataToCheck = {};
      finalData.period = value;
      if (value === 'auto') {
        finalDataToCheck = deepClone(finalData)
      }
      _this.setState({
        [name]: value,
        finalData,
        varCustomInterval: null
      })
      if (isFunc) {
        checkSubmitable('varValue', finalDataToCheck);
      }
    } else if (name === 'varCustomInterval') {
      finalData.interval = value;
      _this.setState({
        [name]: value,
        finalData
      })

      if (isFunc) {
        checkSubmitable('varValue', finalData);
      }
    } else if (name === 'varFilterType') {
      finalData.type = value;
      delete finalData.range
      delete finalData.range_param
      delete finalData.period
      delete finalData.interval
      delete finalData.ndata
      if (value === '') {
        delete finalData.type;
      }
      _this.setState({
        [name]: value,
        finalData,
        varFilter: null,
        varCustomPeriod: null,
        varCustomInterval: null,
        varNData: null
      })
      if (isFunc) {
        checkSubmitable('varValue', {});
      }
    } else if (name === 'varNData') {
      const intValue = parseInt(value);
      finalData.ndata = intValue;
      let check = true;
      if (isJsonEqual(intValue, NaN)) {
        delete finalData.ndata;
        check = false
      }
      if ((intValue < 1 || intValue > 120) && check) {
        check = false
      }
      _this.setState({
        [name]: intValue,
        finalData
      })
      if (isFunc) {
        if (!check) {
          finalData = {}
        }
        checkSubmitable('varValue', finalData);
      }
    } else {
      _this.setState({
        [name]: value
      })
    }
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let allfilters = safeDeepGetWithType(_state, ['filters'], []);
    let varFilterType = safeDeepGetWithType(_state, ['varFilterType'], '');
    let varFilter = safeDeepGetWithType(_state, ['varFilter'], '');
    let varNData = safeDeepGetWithType(_state, ['varNData'], 0);
    let varFilterDefault = safeDeepGetWithType(_state, ['varFilterDefault'], false);
    let varCustomPeriod = safeDeepGetWithType(_state, ['varCustomPeriod'], '');
    let varCustomInterval = safeDeepGetWithType(_state, ['varCustomInterval'], 0);
    let varPeriod = safeDeepGetWithType(_state, ['varPeriod'], '');
    let varInterval = safeDeepGetWithType(_state, ['varInterval'], 0);
    let varFLabel = safeDeepGetWithType(_state, ['varFLabel'], '');
    let filter_type = safeDeepGetWithType(_state, ['filter_type'], '');
    let range_param = safeDeepGetWithType(_state, ['range_param'], 0);
    let menuPeriod = []
    if (filter_type !== '') {
      for (let period in DUMMY_FILTER[filter_type]) {
        const label = upperFirstLetter(period);
        menuPeriod.push(
          <MenuItem key={period} value={period} >{label}</MenuItem>
        )
      }
    }
    let menuInterval = []
    if (varPeriod !== '') {
      if (filter_type === 'hour' && varPeriod === 'minute') {
        for (let interval in DUMMY_FILTER[filter_type][varPeriod][range_param]) {
          const label = safeDeepGetWithType(DUMMY_FILTER, [filter_type, varPeriod, range_param, interval], '');
          if (label !== '')
            menuInterval.push(
              <MenuItem key={interval} value={parseInt(interval)} >{label}</MenuItem>
            )
        }
      } else {
        for (let interval in DUMMY_FILTER[filter_type][varPeriod]) {
          const label = safeDeepGetWithType(DUMMY_FILTER, [filter_type, varPeriod, interval], '');
          if (label !== '')
            menuInterval.push(
              <MenuItem key={interval} value={parseInt(interval)} >{label}</MenuItem>
            )
        }
      }
    }
    let menuFilters = []
    allfilters.forEach((currFilter, index) => {
      let filter_label = safeDeepGetWithType(currFilter, ['label'], '')
      const selectorName = safeDeepGetWithType(currFilter, ['selector_name'], '')
      const value = safeDeepGetWithType(currFilter, ['value'], '')
      const type = safeDeepGetWithType(currFilter, ['type'], '')
      const param = safeDeepGetWithType(currFilter, ['param'], 0)
      let filterValue = {
        value,
        type: type === '' ? null : type,
        param: param === 0 ? null : param
      }
      clean(filterValue);
      if (selectorName !== '') {
        menuFilters.push(
          <MenuItem key={index + 100} disabled value="_!dasdsaSvsaasdas+dasda==">
            <em>{selectorName}</em>
          </MenuItem>
        )
      }
      menuFilters.push(
        <MenuItem key={index} value={stringify(filterValue)} >{filter_label}</MenuItem>
      )
    });
    let menuCustomInterval = []
    if (varCustomPeriod !== '') {
      menuCustomInterval.push(
        <MenuItem key={1} value={1} >1</MenuItem>
      )
      if (varCustomPeriod === 'month') {
        menuCustomInterval.push(
          <MenuItem key={2} value={2} >2</MenuItem>
        )
      } else if (varCustomPeriod === 'hour') {
        menuCustomInterval.push(
          <MenuItem key={2} value={2} >2</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={3} value={3} >3</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={4} value={4} >4</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={6} value={6} >6</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={12} value={12} >12</MenuItem>
        )
      } else if (varCustomPeriod === 'minute') {
        menuCustomInterval.push(
          <MenuItem key={5} value={5} >5</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={10} value={10} >10</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={15} value={15} >15</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={20} value={20} >20</MenuItem>
        )
        menuCustomInterval.push(
          <MenuItem key={30} value={30} >30</MenuItem>
        )
      }
    }
    return (
      <div>
        <FormControl style={{ minWidth: '100%' }}  >
          <TextField
            type="string"
            margin='dense'
            value={varFLabel}
            inputProps={{
              name: 'varFLabel'
            }}
            label={'Label'}
            onChange={_this.handleChange}
          />
        </FormControl>
        <FormControl required style={{ minWidth: '45%', marginRight: 10, marginTop: 10 }}>
          <span>
            <i>Set as Default?</i>
            <Switch checked={varFilterDefault} color="primary" 
            onChange={() => _this.handleChangeToggle('varFilterDefault', varFilterDefault)} />
          </span>
        </FormControl>
        <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
          <InputLabel>Tipe Filter</InputLabel>
          <Select
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            value={varFilterType}
            onChange={_this.handleChange}
            inputProps={{
              name: 'varFilterType'
            }}
          >
            <MenuItem value={'REALTIME'} >Realtime</MenuItem>
            <MenuItem value={'PERIODIC'} >Periodik</MenuItem>
            <MenuItem value={'CUSTOM'} >Custom</MenuItem>
          </Select>
        </FormControl>
        {varFilterType === 'REALTIME' &&
          <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
            <TextField
              error={varNData < 1 || varNData > 120 || isJsonEqual(parseInt(varNData), NaN)}
              label={'N Data'}
              value={varNData}
              onChange={_this.handleChange}
              type={'number'}
              margin='dense'
              inputProps={{ name: 'varNData', min: "1", max: "120", step: "1" }}
            />
            <FormHelperText>Jumlah data terakhir yang akan ditampilkan (min 1,max 120)</FormHelperText>
          </FormControl>
        }
        {varFilterType === 'PERIODIC' &&
          <React.Fragment>
            <FormControl required style={{ minWidth: '100%', marginTop: 5 }} >
              <InputLabel>Pilihan Range</InputLabel>
              <Select
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varFilter}
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varFilter'
                }}
              >
                {menuFilters}
              </Select>
            </FormControl>
            {filter_type !== '' && menuPeriod.length > 0 &&
              <FormControl required style={{ minWidth: '45%', marginTop: 5, marginRight: 5 }} >
                <InputLabel>Data akan ditampilkan dalam satuan waktu</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={varPeriod}
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'varPeriod'
                  }}
                >
                  {menuPeriod}
                </Select>
              </FormControl>
            }
            {varPeriod !== '' && menuInterval.length > 0 &&
              <FormControl required style={{ minWidth: '45%', marginTop: 5, marginRight: 5 }} >
                <InputLabel>Per ... {varPeriod}</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={varInterval}
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'varInterval'
                  }}
                >
                  {menuInterval}
                </Select>
              </FormControl>
            }
          </React.Fragment>
        }
        {varFilterType === 'CUSTOM' &&
          <React.Fragment>
            <FormControl required style={{ minWidth: '45%', marginTop: 5, marginRight: 5 }} >
              <InputLabel>Data akan ditampilkan dalam satuan waktu</InputLabel>
              <Select
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                value={varCustomPeriod}
                onChange={_this.handleChange}
                inputProps={{
                  name: 'varCustomPeriod'
                }}
              >
                <MenuItem value={'auto'} >Auto</MenuItem>
                <MenuItem value={'month'} >Bulan</MenuItem>
                <MenuItem value={'week'} >Minggu</MenuItem>
                <MenuItem value={'day'} >Hari</MenuItem>
                <MenuItem value={'hour'} >Jam</MenuItem>
                <MenuItem value={'minute'} >Menit</MenuItem>
              </Select>
              {varCustomPeriod === 'auto' &&
                <FormHelperText>Otomatis menyesuaikan range waktu yang dipilih</FormHelperText>
              }
            </FormControl>
            {varCustomPeriod !== '' && varCustomPeriod !== 'auto' &&
              <FormControl required style={{ minWidth: '45%', marginTop: 5, marginRight: 5 }} >
                <InputLabel>Per ... {varCustomPeriod}</InputLabel>
                <Select
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  value={varCustomInterval}
                  onChange={_this.handleChange}
                  inputProps={{
                    name: 'varCustomInterval'
                  }}
                >
                  {menuCustomInterval}
                </Select>
              </FormControl>
            }
          </React.Fragment>
        }
      </div >
    );
  }
}